export default {
      id: "icon-event-to-metric-dark-usage",
      viewBox: "0 0 65 64",
      url: "/assets/img" + "symbol-defs.1376f4.svg#icon-event-to-metric-dark-usage",
      toString: function () {
        return this.url;
      }
    }